import { mapActions, mapGetters, mapMutations } from "vuex";

export default {
    name: "specification-form",
    props: {},
    data() {
        return {
            payload: {
                name: '',
                phone: '',
                email: '',
            }
        }
    },
    watch: {
        //
    },
    created() {
        //
    },
    computed: {
        ...mapGetters({
            specificationList: 'constructors/specificationList',
        })
    },
    methods: {
        ...mapActions({
            sendForm: 'constructors/SEND_SPECIFICATION_FORM',
        }),
        ...mapMutations({
            closePopup: 'constructors/SHOW_SPECIFICATION_FORM_POPUP'
        }),
        storeForm() {
            // let errorText = this.$refs.questionError

            // if (!this.payload.message.length) {
            //     this.validMessage = true
            //     errorText.textContent = this.$t('callback.enterText')
            // }
            // if (this.payload.message.length <= 10) {
            //     this.validMessage = true
            //     errorText.textContent = this.$t('validation.minLength', {'size': 10})
            // }
            //
            // if (this.validMessage) {
            //     return;
            // }

            const payload = {
                ...this.payload,
                specification_document_id: this.specificationList.fileName.id,
                page_url: typeof window !== 'undefined' ? window.location.href : '',
            }

            this.sendForm(payload).then((response) => {
                this.$toasted.success(response.message);

                // GTM tracking for successful calculation form submission
                if (typeof window !== 'undefined' && window.dataLayer) {
                    window.dataLayer.push({
                        event: 'calculation_callback_form',
                        phone_number: payload.phone, // номер телефону (без тире та пробілів)
                        email: payload.email // електронна адреса
                    });
                }

                this.closePopup(false)
                document.getElementById('html').classList.remove('hide')
            }).catch(error => {
                this.$toasted.error('error', error);
            })
        }
    },
}
